// Fisher–Yates shuffle (naive)
export const shuffle = <T>(arr: T[]) => {
  // loop backwards
  for (let i = arr.length - 1; i > 0; i -= 1) {
    // j is a random number between 0 and the array length
    const j = Math.floor(Math.random() * (i + 1))
    const temp = arr[i] // store previous value

    // swap places
    arr[i] = arr[j]
    arr[j] = temp
  }
}
